import React from 'react';

import {Button, Icon, Menu, Text} from '@albert-io/atomic';
import type {SelectOption} from 'client/TeacherDashboard/types';

interface Props {
  label: string;
  value: string;
  options: SelectOption<string>[];
  onChange: (value: string) => void;
  name?: string;
}

export const ScopeSelect = ({label, value, options, onChange, name}: Props) => {
  const current = options.find((option) => option.value === value) ?? options[0];
  const hasAllOption = options[0]?.value === '';
  return (
    <div className='flex grow flex-col gap-x0-half'>
      <Text bold size='s'>
        {label}
      </Text>
      <Menu className='w-full' closeOnItemClick position='bottom-start' positionFixed>
        <Menu.Trigger fillWrapper>
          {(triggerProps) => (
            <Button
              {...triggerProps}
              aria-label={label}
              color='secondary'
              variant='outlined'
              roundness='square'
              data-testid={name}
              className='flex w-full items-center justify-between gap-x2 border-border-primary! font-normal!'
            >
              <Text className='truncate' color='primary'>
                {current?.label ?? ''}
              </Text>
              <Icon icon='caret-down' iconStyle='solid' />
            </Button>
          )}
        </Menu.Trigger>
        <Menu.Content className='[&_.o-menu-content]:max-h-[60vh] [&_.o-menu-content]:overflow-y-auto'>
          {options.map((option, index) => (
            <React.Fragment key={option.value}>
              {index === 1 && hasAllOption && <Menu.Divider />}
              <Menu.Item
                selected={option.value === value}
                rightIconProps={option.value === value ? {icon: 'check'} : undefined}
                onClick={() => onChange(option.value)}
              >
                {option.label}
              </Menu.Item>
            </React.Fragment>
          ))}
        </Menu.Content>
      </Menu>
    </div>
  );
};
